module.exports = __webpack_public_path__ + "static/media/star_half.5051491e.png";